import axios from "axios";

const state = {
    user: undefined
};

const getters = {
    isAuthenticated: state => {
        if (state.user === undefined) {
            if(localStorage.getItem('mmr_username')) {
                state.user = localStorage.getItem('mmr_username');
            }
        }
            
        return !!state.user;
    },
    AuthUser: state => state.user,
};

const actions = {
    async LogIn({commit}, User) {
        await axios.post('/login', User);
        await commit('setUser', User.username);
    },
    async LogOut({commit}) {
        commit('logout');
    }
};

const mutations = {
    setUser(state, username) {
        state.user = username;
        localStorage.setItem('mmr_username', username);
    },
    logout(state) {
        state.user = undefined;
        localStorage.removeItem('mmr_username');
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}